const Terms = () => {
    const termsText = `
  이용약관
  
  제1조 (목적)
  본 약관은 [ChainSpace]가 제공하는 NFT 마켓플레이스 서비스(이하 "서비스")의 이용조건 및 절차, 이용자와 회사 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
  
  제2조 (정의)
  1. "회원"이란 본 약관에 동의하고 서비스를 이용하는 자를 말합니다.
  2. "NFT"란 블록체인 기술을 이용하여 디지털 자산을 토큰화한 것을 의미합니다.
  3. "창작자"는 플랫폼에 자신의 디지털 콘텐츠를 업로드하고 NFT로 등록한 회원을 말합니다.
  
  제3조 (이용계약의 성립)
  1. 이용자는 본 약관에 동의함으로써 회원 가입이 완료되며, 서비스 이용 자격을 얻게 됩니다.
  
  제4조 (회원의 의무)
  1. 회원은 관련 법령, 본 약관 및 운영정책을 준수해야 합니다.
  2. 회원은 타인의 지식재산권을 침해해서는 안 됩니다.
  
  제5조 (NFT 거래 및 수수료)
  1. 본 서비스에서 이루어지는 NFT의 거래는 회원 간의 계약에 따라 성립되며, 회사는 이에 따른 중개 수수료를 받을 수 있습니다.
  
  제6조 (서비스의 중단)
  회사는 시스템 점검, 장애, 기타 운영상 필요한 경우 서비스의 전부 또는 일부를 일시적으로 중단할 수 있습니다.
  
  제7조 (면책 조항)
  회사는 회원 간의 NFT 거래에 대해 직접적인 책임을 지지 않습니다.
  
  부칙
  본 약관은 2025년 4월 14일부터 적용됩니다.
  `;
  
    return (
      <div style={{ padding: '2rem', textAlign: 'left' }}>
        <h1>이용약관</h1>
        <p style={{ whiteSpace: 'pre-line' }}>{termsText}</p>
      </div>
    );
  };
  
  export default Terms;  